import React, { useEffect } from "react";
import Hero from "@/components/Hero";
import StatsStrip from "@/components/StatsStrip";
import Marquee from "@/components/Marquee";
import WhatIsSection from "@/components/WhatIsSection";
import Conditions from "@/components/Conditions";
import Procedures from "@/components/Procedures";
import ChoiceOfSpecialist from "@/components/ChoiceOfSpecialist";
import WhyChoose from "@/components/WhyChoose";
import PatientJourney from "@/components/PatientJourney";
import PatientEducation from "@/components/PatientEducation";
import InstagramReels from "@/components/InstagramReels";
import Testimonials from "@/components/Testimonials";
import FAQ from "@/components/FAQ";
import Articles from "@/components/Articles";
import FinalCTA from "@/components/FinalCTA";
import { FAQS } from "@/data/content";
import { removePrerenderedSchemas } from "@/lib/schema-helpers";

// Homepage-only FAQPage schema (SEO pages/blog posts emit their own)
const useHomeFaqSchema = () => {
  useEffect(() => {
    removePrerenderedSchemas();
    const el = document.createElement("script");
    el.type = "application/ld+json";
    el.setAttribute("data-home-faq-schema", "true");
    el.text = JSON.stringify({
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: FAQS.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    });
    document.head.appendChild(el);
    return () => { document.head.removeChild(el); };
  }, []);
};

const Home = () => {
  useHomeFaqSchema();
  return (
    <>
      <Hero />
      <StatsStrip />
      <Marquee />
      <WhatIsSection />
      <Conditions />
      <Procedures />
      <ChoiceOfSpecialist />
      <WhyChoose />
      <PatientJourney />
      <PatientEducation />
      <InstagramReels />
      <Testimonials />
      <FAQ />
      <Articles />
      <FinalCTA />
    </>
  );
};

export default Home;
